import { createRouter, createWebHistory } from 'vue-router';
import AppLayout from '@/layout/AppLayout.vue';
import config from '@/config';
import { buildRouteMeta } from '@/router/routeMeta';

const routes = [
    {
        path: '/',
        component: AppLayout,
        children: [
            {
                path: '',
                name: 'home',
                meta: {
                    breadcrumb: [{
                        title: 'Home',
                        name: 'home',
                        icon: 'pi pi-home'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                },
                component: () => import('@/views/pages/Home.vue')
            },
            {
                path: '/integration-lab/list',
                name: 'integration-lab.list',
                meta: buildRouteMeta('integration-lab', {
                    breadcrumb: [{
                        title: 'Integration Lab',
                        name: 'integration-lab.list',
                        icon: 'integration-lab-image'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/integration-lab/List.vue')
            },
            {
                path: '/integration-lab/share',
                name: 'integration-lab.share',
                meta: buildRouteMeta('integration-lab', {
                  breadcrumb: [{
                    title: 'Share',
                    name: 'integration-lab.share',
                    icon: 'integration-lab-image'
                  }],
                  requiresAuth: true,
                  allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/integration-lab/Share.vue')
            },
            {
                path: '/ps-customer-server/list',
                name: 'ps-customer-server.list',
                meta: buildRouteMeta('ps-customer-server', {
                    breadcrumb: [{
                        title: 'PS Customer Server',
                        name: 'ps-customer-server.list',
                        icon: 'ps-customer-image'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/ps-customer-server/List.vue')
            },
            {
                path: '/ps-estimate/list',
                name: 'ps-estimate.list',
                meta: buildRouteMeta('ps-estimate', {
                    breadcrumb: [{
                        title: 'PS Estimate',
                        name: 'ps-estimate.list',
                        icon: 'ps-customer-image'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/ps-estimation/List.vue')
            },
            {
                path: '/ps-customer-server/add',
                name: 'ps-customer-server-add',
                meta: buildRouteMeta('ps-customer-server', {
                    breadcrumb: [{
                        title: 'PS Customer Server',
                        name: 'ps-customer-server.list',
                        icon: 'ps-customer-image'
                    },
                    {
                        title: 'Add',
                        name: 'ps-customer-server-add',
                        icon: ''
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/ps-customer-server/Add.vue')
            },
            // {
            //     path: '/site-assessment/list',
            //     name: 'site-assessment.list',
            //     meta: {
            //         breadcrumb: [
            //             {
            //                 title: 'Site Assessment',
            //                 name: 'site-assessment.list',
            //                 icon: ''
            //             },
            //         ]
            //     },
            //     component: () => import('@/views/site-assessment/List.vue')
            // },
            // {
            //     path: '/site-assessment/add',
            //     name: 'site-assessment.add',
            //     meta: {
            //         breadcrumb: [
            //             {
            //                 title: 'Site Assessment',
            //                 name: 'site-assessment.list',
            //                 icon: ''
            //             },
            //             {
            //                 title: 'Add',
            //                 name: 'site-assessment.add',
            //                 icon: ''
            //             }
            //         ]
            //     },
            //     component: () => import('@/views/site-assessment/Add.vue')
            // },
            //NOTE: New Site Assessment Start
            {
                path: '/site-assessment/list',
                name: 'site-assessment.list',
                // CCRM OAuth callback is registered as site-assessment/list; forward auth code/error to ps-estimate
                beforeEnter: (to) => {
                    if (to.query.code || to.query.error) {
                        return { name: 'ps-estimate.list', query: to.query };
                    }
                },
                meta: buildRouteMeta('site-assessment', {
                    breadcrumb: [
                        {
                            title: 'Site Assessment List',
                            name: 'site-assessment.list',
                            icon: 'site-assessment-image'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/new-site-assessment/List.vue')
            },
            {
                path: '/site-assessment/add',
                name: 'site-assessment.add',
                meta: buildRouteMeta('site-assessment', {
                    breadcrumb: [
                        {
                            title: 'Site Assessment List',
                            name: 'site-assessment.list',
                            icon: 'site-assessment-image'
                        },
                        {
                            title: 'Add',
                            name: 'site-assessment.add',
                            icon: ''
                        }
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/new-site-assessment/Add.vue')
            },
            {
                path: '/site-assessment/view/:id',
                name: 'site-assessment.view',
                meta: buildRouteMeta('site-assessment', {
                    breadcrumb: [
                        {
                            title: 'Site Assessment List',
                            name: 'site-assessment.list',
                            icon: 'site-assessment-image'
                        },
                        {
                            title: 'View',
                            name: 'site-assessment.view',
                            icon: ''
                        }
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/new-site-assessment/View.vue')
            },
            //NOTE: New Site Assessment End
            // {
            //     path: '/transformer/list',
            //     name: 'transformer.list',
            //     meta: {
            //         breadcrumb: [
            //             {
            //                 title: 'Transformer',
            //                 name: 'site-assessment.transformer',
            //                 icon: 'pi pi-cog'
            //             },
            //         ]
            //     },
            //     component: () => import('@/views/transformer/List.vue')
            // },
            {
                path: '/ddi-library/list',
                name: 'ddi-library.list',
                meta: buildRouteMeta('ddi-library', {
                    breadcrumb: [
                        {
                            title: 'DDI Library',
                            name: 'ddi-library.list',
                            icon: 'ddi-library-image'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin]
                }),
                component: () => import('@/views/ddi-library/List.vue')
            },
            {
                path: '/master-variable/list',
                name: 'master-variable.list',
                meta: buildRouteMeta('master-variable', {
                    breadcrumb: [
                        {
                            title: 'Master Variable',
                            name: 'master-variable.list',
                            icon: 'master-variable-image'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin]
                }),
                component: () => import('@/views/master-variable/List.vue')
            },
            {
                path: '/data-sync/list',
                name: 'data-sync.list',
                meta: buildRouteMeta('data-sync', {
                    breadcrumb: [
                        {
                            title: 'Data Sync',
                            name: 'data-sync.list',
                            icon: 'data-sync-image'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin]
                }),
                component: () => import('@/views/data-sync/List.vue')
            },
            {
                path: '/gateway-management/index',
                name: 'gateway-management.index',
                meta: buildRouteMeta('gateway-management', {
                    breadcrumb: [
                        {
                            title: 'Gateway Management',
                            name: 'gateway-management.index',
                            icon: 'gateway-management-image'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin]
                }),
                component: () => import('@/views/gateway-management/List.vue')
            },
            {
                path: '/unit/list',
                name: 'unit.list',
                meta: buildRouteMeta('unit', {
                    breadcrumb: [
                        {
                            title: 'Unit',
                            name: 'unit.list',
                            icon: 'unit-image'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin]
                }),
                component: () => import('@/views/unit/List.vue')
            },
            {
                path: '/patient-tile-composer/list',
                name: 'patient-tile-composer.list',
                meta: buildRouteMeta('patient-tile-composer', {
                    breadcrumb: [
                        {
                            title: 'Patient Tile Designer List',
                            name: 'patient-tile-composer.list',
                            icon: 'patient-tile-composer-image'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/patient-tile-composer/List.vue')
            },
            {
                path: '/patient-tile-composer/:id',
                name: 'patient-tile-composer.view',
                meta: buildRouteMeta('patient-tile-composer', {
                    breadcrumb: [
                        {
                            title: 'Patient Tile Designer',
                            name: 'patient-tile-composer.list',
                            icon: 'patient-tile-composer-image'
                        },
                        {
                            title: 'View',
                            name: 'patient-tile-composer.view',
                            icon: 'patient-tile-composer-image'
                        }
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/patient-tile-composer/View.vue')
            },
            {
                path: '/patient-tile-composer/add',
                name: 'patient-tile-composer.add',
                meta: buildRouteMeta('patient-tile-composer', {
                    breadcrumb: [
                        {
                            title: 'Patient Tile Designer Add',
                            name: 'patient-tile-composer.add',
                            icon: 'patient-tile-composer-image'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/patient-tile-composer/Add.vue')
            },
            {
                path: '/go-live-generator',
                name: 'go-live-generator.index',
                meta: buildRouteMeta('go-live-generator', {
                    breadcrumb: [{
                        title: 'Go-Live Generator',
                        name: 'go-live-generator.index',
                        icon: 'pi pi-envelope'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/go-live-generator/Index.vue')
            },
            {
                path: '/cables-lookup',
                name: 'cables-lookup.index',
                meta: buildRouteMeta('cables-lookup', {
                    breadcrumb: [{
                        title: 'Cables Lookup',
                        name: 'cables-lookup.index',
                        icon: 'cables-lookup-image'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/cables-lookup/Index.vue')
            },
            {
                path: '/mp1-data-analyzer/analyzer',
                name: 'mp1-data-analyzer.analyzer',
                meta: buildRouteMeta('mp1-data-analyzer', {
                    breadcrumb: [
                        {
                            title: 'MP1 Data Analyzer',
                            name: 'mp1-data-analyzer.analyzer',
                            icon: 'pi pi-chart-line'
                        },
                    ],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin]
                }),
                component: () => import('@/views/mp1-data-analyzer/analyzer.vue')
            },
            {
                path: '/license-tracker/list',
                name: 'license-tracker.list',
                meta: buildRouteMeta('license-tracker', {
                    breadcrumb: [{
                        title: 'License Tracker',
                        name: 'license-tracker.list',
                        icon: 'license-tracker-image'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/license-tracker/List.vue')
            },
            {
                path: '/license-tracker/add',
                name: 'license-tracker-add',
                meta: buildRouteMeta('license-tracker', {
                    breadcrumb: [{
                        title: 'License Tracker',
                        name: 'license-tracker.list',
                        icon: 'license-tracker-image'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin, config.userType.user]
                }),
                component: () => import('@/views/license-tracker/Add.vue')
            },
            {
                path: '/admin/deployment-settings',
                name: 'deployment-settings.list',
                meta: {
                    breadcrumb: [{
                        title: 'Deployment Settings',
                        name: 'deployment-settings.list',
                        icon: 'pi pi-cog'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin]
                },
                component: () => import('@/views/deployment-settings/List.vue')
            },
            {
                path: '/admin/login-history',
                name: 'login-history.list',
                meta: {
                    breadcrumb: [{
                        title: 'Login History',
                        name: 'login-history.list',
                        icon: 'pi pi-history'
                    }],
                    requiresAuth: true,
                    allowedUsers: [config.userType.admin]
                },
                component: () => import('@/views/login-history/List.vue')
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/pages/auth/Login.vue')
    },
    {
        path: '/auto-login',
        name: 'auto-login',
        component: () => import('@/views/pages/auth/AutoLogin.vue')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/pages/404.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/404'
    },
    {
        path: '/saml/acs-verify-token',
        name: "token",
        component: () => import('@/views/pages/auth/Callback.vue'),
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    }
});

export default router;
